<template>
    <v-layout row text-align-left>
        <v-flex class="xs4 pl-4">{{ days[index] }}:</v-flex>
        <v-flex class="xs4">
            {{ isAvailable }}
        </v-flex>

        <v-flex v-if="day" :class="sizeClass+' xs4'">
            {{ time }}
        </v-flex>
        <v-flex v-else :class="sizeClass+ ' xs4'">

        </v-flex>

    </v-layout>
</template>

<script>
  import utils from '@/utils.js'

  export default {
      props: ['index', 'day', 'timeRange'],
      data () {
        return {
            // timeRange: [0, 1440],
            days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
        }
      },
      watch: {
          updateNum: function() {
              // This is simply to force a redraw

          }
      },
      computed: {
          isAvailable: function () {
              if (this.day) {
                  return "Available"
              } else {
                  return "Not available"
              }
          },
          time: function () {
              // console.log("TIME RANGE is: "+ this.timeRange)
              if (this.timeRange != undefined ) {
                  return  utils.minutesToTime(this.timeRange[0]) + " to " + utils.minutesToTime(this.timeRange[1])
              } else {
                  return "UNDEFINED"
              }

          },
          sizeClass: function () {
              if (this.$vuetify.breakpoint.xsAndDown) {
                  return "caption"
              } else {
                  return ""
              }
          }
      },
      // mounted: function() {
      //     console.log("DAY Hours Mounted: "+this.isAvailable+" "+this.index+" timeR:"+this.timeRange)
      //
      // },
      methods: {


      }

  }
</script>

<style>

</style>
